import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    activeFilters: {
      display: 'flex',
      flexWrap: 'nowrap',
      gap: theme.spacing(1),
      marginBottom: 0,
      overflowX: 'auto',
      scrollbarWidth: 'none',
      whiteSpace: 'nowrap',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(.6),
      },
    },

    button: {
      '&:not(:last-child)': {
        marginRight: 0,
      },
      flex: '0 0 auto',
      marginBottom: 0,
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('sm')]: {
        fontSize: '.76rem',
        minHeight: 34,
        paddingLeft: theme.spacing(1.1),
        paddingRight: theme.spacing(.7),
        '& .MuiButton-endIcon': {
          marginLeft: theme.spacing(.5),
        },
      },
    },

  })
)

export default useStyles
